import gql from "graphql-tag";

export default gql`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`;
